import React from 'react';
import {renderIcon} from '~/common/canvas/renderIcon';
import DuplicateIcon from '~library/svg/icons/DuplicateIcon.svg';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {toastAlert} from '~library/atoms/Toast';
import {canvasAddTextBorderAndIcon, canvasShowTextBordersAndIcons} from '../customs/text_border';

export const cloneControl = () => {
  const cloneObject = (eventData, transform) => {
    const {target} = transform;
    const {canvas} = target;
    const textsQty = canvas.getObjects().filter((obj) => obj.type === 'textbox').length;
    if (textsQty < 8) {
      target.clone((cloned) => {
        canvas.add(
          cloned.set({
            left: target.left + 50,
            top: target.top + 50,
            text: target.text,
            letterCasing: target?.letterCasing,
            _originalObject: JSON.parse(JSON.stringify(target)),
          })
        );
        canvas.setActiveObject(cloned);
        canvasShowTextBordersAndIcons(canvas);
        canvasAddTextBorderAndIcon(cloned, canvas, textsQty + 1);
      });
    } else {
      toastAlert('Maximum number of text boxes has been reached', {
        type: 'error',
        icon: <AlertLineIcon ratio={0.65} />,
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const padding = 9;

  return new fabric.Control({
    x: 0,
    y: -0.5,
    offsetX: 22,
    offsetY: -16 - padding,
    cursorStyle: 'pointer',
    mouseUpHandler: cloneObject,
    render: renderIcon({icon: DuplicateIcon, padding}),
    cornerSize: 16,
    touchSizeX: 32,
    touchSizeY: 32,
    sizeX: 30,
    sizeY: 30,
  });
};
